import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import { CheckBox } from "devextreme-react";
import Form, { SimpleItem } from "devextreme-react/form";
//devex
import { useTranslation } from "react-i18next";
import { AnyState } from "robodux";

// import { Case, CaseElse, Switch } from '@app/context';
// import { usePdfContext } from '@app/context/pdfData';
// import { listPrepareSetModel, selectListReportUi_currentListOpsData } from '@app/state/apis/uiList';
// helpers //
import { commonStyle } from "@app/style/commonForms";
import "@app/style/dx.generic.jurnalKarma1.css";

/* -------------------------------------------------------------------------- */
import { useAppDispatch } from "../../state";
import "./lists_common.scss";

import type { FormRef } from "devextreme-react/form";
// unfinished form for report options, may be used in future//
export const AForm = ({ theStoreState }: { theStoreState: AnyState }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const formformref = useRef<FormRef>(null);
  const dataRef = useRef({});
  const [, jet] = useState(0);
  const commonTextEditOptions = {
    ...commonStyle({ elementclass: "filledunderline" }),
  };
  // todo or not //
  const isDirty = () => false;
  // todo //
  const isReadOnly = useMemo(() => false, []);

  const fieldDataChanged = (e: any) => {
    let { value } = e || {};
    const { dataField } = e || {};
    if (!dataField) {
      return;
    }
    if (value === "") {
      value = null;
    }
    const newState = { ...dataRef.current, [dataField]: value };
    dataRef.current = newState;
  };
  useEffect(() => {
    if (JSON.stringify(dataRef.current) !== JSON.stringify(theStoreState)) {
      dataRef.current = { ...theStoreState };
      jet(Math.random());
    }
  }, [JSON.stringify(theStoreState)]);

  const customizeFormIems = (item: any) => {
    item.editorOptions = { ...commonTextEditOptions };
  };
  const onFormSubmit = useCallback((e: any) => {
    void 0;
  }, []);
  return (
    <form onSubmit={onFormSubmit}>
      <Form
        ref={formformref}
        id={"formformLxModelSave"}
        className={`form-form org-data ${isDirty() ? "edited" : ""}`}
        formData={{ ...dataRef.current }}
        showColonAfterLabel={true}
        labelLocation={"left"}
        colCount={3}
        width={400}
        onFieldDataChanged={fieldDataChanged}
        readOnly={isReadOnly}
        customizeItem={customizeFormIems}
      >
        <SimpleItem
          colSpan={2}
          editorType={"dxSwitch"}
          dataField={"include_db_of_persons"}
          label={{ text: "Include ", location: "left" }}
        />
      </Form>
    </form>
  );
};

export const SelAsListItem4Contacts = () => {
  return (
    <div className={"criteria-in-list lildetail-group dx-swatch-jurnalKarma1"}>
      <CheckBox text="Contacte" defaultValue={true} />
      <CheckBox text="Persoane" defaultValue={true} />
    </div>
  );
};
